import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { UserContext } from "../../../context";
import { Modal } from "../../../components";
import { useActasStore } from "../../../store/actasStore";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import DetalleDeActa from "../../../components/DetalleDeActa";
import { controlHideActaDetalleHandler } from "../../../handlers/actaDetalle.handler";
import { refreshControl } from "../../../services/detalleActa.service";

const ModalActaDetalle2 = ({ type, setRefetch }) => {

    //? OLD
    const { handlerModal, modals } = useGeneralAppStore();
    const { actasDetalle, setActaDetalle } = useActasStore();
    const { actions } = useContext(UserContext);



    const { actaDetalle, acta, archivos, alertas, coleccionActasDetalle } = useActaDetalleStore();
    const location = useLocation();
    const prevLink = "/" + location.pathname.split("/").filter((segmento) => segmento)[0];

    useEffect(() => {
        return async () => {
            const actaActual = acta;
            setActaDetalle(null);
            handlerModal({ modal: false, modalName: 'acta_detalle' })
            if (actaActual &&  ((actions.hasRole('admin') || actions?.hasRole('admin.app')) && ![1, 4, 11, 12, 13, 14, 15,19]?.includes(actaActual?.estado_id))) {
                await controlHideActaDetalleHandler(actaActual);
}
            setRefetch && setRefetch(true)
        }
    }, [])

    useEffect(() => {
        if (alertas?.length > 0) {
            handlerModal({ modal: true, modalName: "alertas_acta" });
        }
    }, [])



    useEffect(() => {
        if (actions?.hasRole('admin') || actions?.hasRole('admin.app')) {
            const intervalo = setInterval(() => {
                refreshControl({ id_acta: acta?.id, accion: 'show' });

            }, 4 * 60 * 1000); // 5 minutos

            return () => clearInterval(intervalo);
        }

    }, []);



    return (
        <>
            <Modal
                fullscreen={true}
                show={modals.includes('acta_detalle')}
                size="xl"
                onHide={() => { handlerModal({ modal: false, modalName: 'acta_detalle' }) }}
                title={() => "Detalle acta"}
            >
                <DetalleDeActa  />
            </Modal>
        </>
    );
};

export default ModalActaDetalle2;
